import * as React from "react";
import type { SVGProps } from "react";
const SvgIconUserCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.32.82C6.07 1.07 4.3 2.79 4.02 5c-.23 1.8.56 3.59 2.06 4.62 1.62 1.1 3.75 1.13 5.4.05 1.99-1.31 2.72-3.87 1.74-6.05-.29-.63-.76-1.25-1.32-1.71-.65-.55-1.5-.93-2.34-1.06C9.27.8 8.58.79 8.32.82m.1 1.71-.25.05c-.54.1-1.08.39-1.5.8q-.72.68-.91 1.64c-.06.28-.07.83-.03 1.1.07.37.23.81.4 1.11.39.64 1.04 1.15 1.74 1.37.62.2 1.34.19 1.93-.01 1.1-.38 1.91-1.33 2.1-2.45.03-.26.04-.72 0-.96-.2-1.34-1.25-2.41-2.57-2.63-.2-.03-.8-.04-.92-.02m-.04 9.42c-3.11.16-5.86 2.14-7.02 5.05q-.37.95-.51 2c-.03.23-.04.5-.04 1.13v.83l.07.16q.16.31.46.44l.14.05h8.16l.13-.05q.3-.13.46-.43c.21-.44.03-.94-.43-1.16l-.14-.06-3.57-.01H2.52v-.2l.04-.48c.28-2.39 1.91-4.43 4.18-5.22 2.33-.8 4.96-.17 6.63 1.6.6.65.93 1.16 1.3 2 .14.35.24.47.46.58.43.21.94.04 1.16-.4.06-.12.07-.15.07-.36s-.01-.25-.1-.45c-.5-1.25-1.36-2.4-2.41-3.26-1.25-1.01-2.9-1.66-4.43-1.75-.53-.03-.68-.03-1.04 0m13.76 1.6q-.2.06-.34.18c-.05.04-1.4 1.73-3.01 3.74l-2.95 3.68-1.33-.98c-1.47-1.1-1.45-1.08-1.76-1.06q-.5.04-.72.49c-.07.13-.08.18-.08.32 0 .09 0 .2.02.24.02.12.12.3.2.38s3.08 2.34 3.34 2.52c.25.17.57.19.85.05.08-.04.18-.1.22-.15l3.28-4.09c1.96-2.45 3.23-4.05 3.27-4.14.06-.1.07-.16.07-.34 0-.2-.01-.24-.07-.36q-.13-.27-.4-.41c-.11-.06-.17-.07-.32-.08-.11 0-.23 0-.27.02"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconUserCheck;
